import React from 'react';
import './tableSkeleton.scss';

type PropsType = {
    rows?: number,
    columns: []
};


const TableSkeleton = ({ rows = 10, columns }: PropsType) => {
    const renderRow = () => {
        const res = [];

        for (let i = 0; i < columns.length; i++) {
            if (!(i === 0 && !columns[i].name)) {
                res.push(
                    <td className="tg-cly1">
                        {
                            columns[i].name &&
                            <div className="line" />
                        }
                    </td>
                );
            }
        }
        return res;
    };
    const renderBody = () => {
        const res = [];

        for (let i = 0; i < rows; i++) {
            res.push(
                <tr>{renderRow()}</tr>
            );
        }
        return res;
    };

    return (
        <table className="tg">
            {renderBody()}
        </table>
    );
};

export default TableSkeleton;